import { Injector } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { getConditionalSettingsForm } from '../../conditional-settings-configurations';
import { getDefaultBaseSettingsConfigFormly } from '../../form-fields-formly-settings/form-builder-default-settings-configuration-formly-fields.utils';
import {
  checkboxFieldParseIntoSettingsFormModel,
  checkboxFieldUpdateFromSettingsFormModel,
  defaultCheckboxConfigFormModel,
} from '../checkbox-field-type.configuration';
import { BaseFormlyFieldConfiguration } from './base-formly-field-configuration';

export class CheckboxFormlyFieldConfiguration extends BaseFormlyFieldConfiguration {
  constructor(injector: Injector, field: FormlyFieldConfig) {
    super(injector, field);
    this.availableValidations = ['required'];
    this.availableConditionalValidations = ['required'];
    this.settingsFormlyModel = defaultCheckboxConfigFormModel;
    this.settingsFormlyForm = [
      ...getDefaultBaseSettingsConfigFormly(this.formBuilderService),
      getConditionalSettingsForm(this.formBuilderService),
    ];
  }

  override parseFieldConfigIntoSettingsFormModel() {
    return checkboxFieldParseIntoSettingsFormModel(this.field);
  }

  override updateFieldConfigFromSettingsFormModel(
    model: any
  ): FormlyFieldConfig {
    return checkboxFieldUpdateFromSettingsFormModel(model, this.field);
  }
}
